import * as React from 'react';
import { ConfiguratorContext } from './ConfigContextProvider';
import { isReadOnly, fromInt, useValidation, getOptionModel, configEventControlType, configEvents, setOptionValueChanged, useRefreshKey, optionAccessibleName } from './ProductConfiguratorShared';
import { AccentLengthUnbound } from '../unbound/AccentLengthUnbound';

export const ConfigLength = props => {

    const focusBug = React.useRef(false);

    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);


    const settings = optionModel.GetLengthSettings();

    
    const validation = useValidation(props.optionID, "ConfigLength");

    const [value, setValue] = React.useState(optionModel.CurrentValue);

    const refreshKey = useRefreshKey(props.optionID, value);

    const onChange = React.useCallback(e => {

        const wasFocused = focusBug.current;
        focusBug.current = false;

        try {
            optionModel.UpdateFrom$1(e);
            setOptionValueChanged(ctx, optionModel);
            setValue(e);
        } finally {
            // Release the focus wait only after the value and its rules are applied.
            // A duplicate blur must not consume another pending configuration event.
            if (wasFocused) {
                ctx.config?.Publish(configEvents.controlLostFocus, configEventControlType.decimal);
            }
        }

    }, [setValue, ctx, optionModel]);

    const onFocus = React.useCallback(e => {
        if (!focusBug.current) {
            focusBug.current = true;
            ctx.config?.Publish(configEvents.controlGotFocus, configEventControlType.decimal);
        }

    }, [ctx]);

    const notifyDirty = React.useCallback(e => {

        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);

    const readOnly = isReadOnly(optionModel);

    const min = fromInt(optionModel.MinValue);
    const max = fromInt(optionModel.MaxValue);


    

    return <div className="config-control config-length">
        <AccentLengthUnbound
            key={refreshKey.refreshID}
            defaultUnit={settings?.Unit ?? 10}
            precision={settings?.Precision}
            required={validation.required}
            defaultValue={optionModel.CurrentValue}
            onBlur={onChange}
            onChange={notifyDirty}
            onFocus={onFocus}
            disabled={readOnly}
            min={min}
            max={max === 0 ? undefined : max}
            debounceMilliseconds={50}
            ariaLabel={optionAccessibleName(optionModel)}
        />
    </div>;

};
